export default __webpack_public_path__ + "static/media/shape4.3a596261.svg";